module.exports = __webpack_public_path__ + "img/buy0338.231ba071.svg";